import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=33f0c7f4&scoped=true&lang=pug"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=33f0c7f4&prod&lang=scss&scoped=true"
import style1 from "./ForgetPassword.vue?vue&type=style&index=1&id=33f0c7f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.105.4__lodash@4_d129e92f74051bdaf507e89873890984/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f0c7f4",
  null
  
)

export default component.exports